<template>
  <span :class="[
    'asm-value',
     {[`asm-value--size-${size}`]: size}]"
  >
    {{ priceDisplay(num, hideChange) }}<span class="asm-value__measure">{{ measure }}</span>
  </span>
</template>

<script>
  import priceFormatter from "../mixins/priceFormatter";

  export default {
    name: "Value",
    mixins: [
      priceFormatter
    ],
    inheritAttrs: false,
    props: {
      hideChange: {
        type: Boolean,
        default: false
      },
      num: {
        type: [Number, String],
        default: 0
      },
      measure: {
        type: String
      },
      size: {
        type: String,
        default: 'sm',
        validate: (v) => ['sm', 'md', 'lg'].includes(v)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .asm-value {
    display: inline-block;
    white-space: nowrap;

    &__measure {
      margin-left: 0.5em;
    }

    &--size-md {
      font-style: normal;
      font-weight: 500;
      font-size: 1em;
      line-height: 1.5em;
    }

    &--size-lg {
      font-style: normal;
      font-weight: 500;
      font-size: 1.5em;
      line-height: 1em;
    }
  }
</style>
